<template>
  <div class="partnersLogo">
    <div class="partner-filter">
      <div class="sticky">
        <div class="filter" v-if="filters && filters.length > 0">
          <sc-text
            tag="span"
            class="filter__title"
            v-if="fields && fields.filtersLabel"
            :field="fields.filtersLabel"
          />

          <div v-for="name in filters" :key="name.id" class="checkbox-container">
            <label class="c-checkbox" :for="`${name.id}`">
              <input
                type="checkbox"
                name="partners"
                class="c-checkbox"
                :checked="isSelected(name.id)"
                :id="`${name.id}`"
                :value="name.id"
                @change="togglePartner"
              />
              <span>{{ name.fields.name.value }}</span>
            </label>
          </div>
          <span
            :disabled="selectedPartnersIds.length === 0"
            :class="{ disabled: selectedPartnersIds.length === 0 }"
            class="clearFilter"
            @click="clearFilter()"
            >Clear Filters</span
          >
        </div>
        <sc-placeholder
          class="partner-placeholder"
          name="jss-partner-logo-wall-filter"
          :rendering="rendering"
        />
      </div>
    </div>
    <div v-if="loading">Loading...</div>
    <div v-else class="partner-container">
      <div
        v-if="selectedPartners.filteredItems.length === selectedPartners.items.length"
        class="listLabel"
      >
        Showing All
      </div>
      <div v-else class="listLabel">
        Showing {{ selectedPartners.filteredItems.length }} of {{ selectedPartners.items.length }}
      </div>
      <div class="partner-list">
        <a
          v-for="item in selectedPartners.filteredItems"
          :key="item.id"
          class="partner-list__item"
          :href="item.url"
        >
          <div class="ribbon">
            <div
              class="ribbon-container"
              v-if="item.accredited?.value === '1' || item.credited?.value === '1'"
            >
              <div v-if="item.accredited?.value === '1'">Accredited</div>
              <div
                v-if="item.accredited?.value === '1' && item.credited?.value === '1'"
                class="divider"
              ></div>
              <div v-if="item.credited?.value === '1'">Credited</div>
            </div>
          </div>
          <div
            class="partner-content"
            :class="{ center: item && !item.featuredImage?.jss?.value?.src }"
          >
            <div class="logo-container" v-if="item && item.featuredImage?.jss?.value?.src">
              <img
                :src="item.featuredImage.jss.value.src"
                :alt="item.featuredImage.jss.value.alt"
              />
            </div>
            <div class="title">{{ item.pageTitle.value }}</div>
          </div>
          <div class="cta">See Details</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue';
import { PartnersQuery } from './CIS-Partner-Logo-Wall-Filter.graphql';
import { useQuery } from '@vue/apollo-composable';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

const filterSort = (a, b) => {
  const nameA = a?.pageTitle?.value?.trim().toUpperCase();
  const nameB = b?.pageTitle?.value?.trim().toUpperCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

export default {
  name: 'CIS-Partner-Logo-Wall-Filter',
  components: {
    ScPlaceholder: Placeholder,
    ScText: Text
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    rendering: {
      type: Object
    }
  },
  data: function () {
    return {
      selectedPartnersIds: []
    };
  },
  setup(props) {
    const variables = () => {};
    const queryOptions = () => {
      return {
        prefetch: true
      };
    };

    const { result, loading, error, onResult } = useQuery(PartnersQuery, variables, queryOptions);

    const selectedPartners = reactive({
      items: [],
      filteredItems: []
    });

    onResult((queryResult) => {
      if (queryResult) {
        if (!queryResult.loading && queryResult.data?.items?.children) {
          const filterPartners = queryResult.data?.items?.children
            .filter((c) => {
              if (c?.partnerTypes && c?.partnerTypes?.value) {
                const partnerArray = c?.partnerTypes?.value
                  ?.replaceAll('{', '')
                  .replaceAll('}', '')
                  .split('|');

                return props.fields?.partners?.some((name) =>
                  partnerArray?.includes(name?.id?.toUpperCase())
                );
              }
            })
            ?.sort(filterSort);

          selectedPartners.items.push(...filterPartners);
          selectedPartners.filteredItems.push(...filterPartners);
        }
      }
    });

    return {
      selectedPartners,
      result,
      loading,
      error
    };
  },
  computed: {
    filters() {
      return this.fields?.filters || [];
    }
  },
  methods: {
    isSelected(partnerId) {
      return !!this.selectedPartnersIds.includes(partnerId);
    },
    togglePartner(e) {
      let partnerId = e.target?.value || e.srcElement?.value;

      const partner = this.filters.find(({ id }) => id === partnerId);
      if (!partner) return;

      const partnerIdIndex = this.selectedPartnersIds.findIndex((t) => t === partner.id);

      if (partnerIdIndex >= 0) {
        this.selectedPartnersIds.splice(partnerIdIndex, 1);
      } else {
        this.selectedPartnersIds.push(partner.id);
      }

      this.selectedPartners.filteredItems = this.selectedPartners.items.filter((s) => {
        if (this.selectedPartnersIds.length > 0) {
          const myArray = s.partnerTypes?.value
            ?.replaceAll('{', '')
            ?.replaceAll('}', '')
            ?.split('|');

          return this.selectedPartnersIds.some((name) => myArray.includes(name?.toUpperCase()));
        } else {
          return s;
        }
      });
    },
    clearFilter() {
      this.selectedPartnersIds = [];
      this.selectedPartners.filteredItems = [];
      this.selectedPartners.filteredItems.push(...this.selectedPartners.items);
    }
  }
};
</script>
<style lang="scss">
.c-site .tippy-box {
  max-width: 59rem !important;
}
</style>
<style lang="scss" scoped>
.partnersLogo {
  @include desktop-up {
    display: flex;
    margin-top: 5rem;
  }

  .partner {
    &-filter {
      background: $white;
      position: sticky;
      top: 6.5rem;
      z-index: 2;

      @include tablet-up {
        top: 5.5rem;
      }

      @include desktop-up {
        width: 32.5rem;
        margin-right: 5rem;
      }

      .sticky {
        position: relative;

        @include desktop-up {
          position: sticky;
          top: 5.5rem;
          z-index: 1;
          display: block;
        }
      }

      .filter {
        background-color: $white;
        padding: 2rem;
        margin-bottom: 2rem;
        border: 0.5px solid #f3f4f4;
        box-shadow: 0 1.6rem 1.6rem 0 rgba(0, 0, 0, 0.04), 0 4px 8px 0 rgba(0, 0, 0, 0.04);

        @include desktop-down {
          width: 100%;
          z-index: 1;
          display: block;
        }

        &__title {
          display: block;
          @include font-styles('Arial', 2rem, 500, normal, 2.8rem, 0, $blue);
          margin-bottom: 2.4rem;
        }

        .checkbox-container {
          margin-bottom: 1.5rem;

          &:last-child {
            margin-bottom: 0;
          }
        }

        input {
          display: none;
        }

        label {
          display: block;
          position: relative;
          padding-left: 4rem;
          cursor: pointer;

          span {
            display: inline-block;
            @include font-styles('Arial', 1.6rem, 200, normal, 2rem, 0, $gray);

            @include tablet-up {
              font-size: 1.6rem;
              line-height: 2rem;
            }

            @include desktop-up {
              font-size: 1.8rem;
              line-height: 2.2rem;
            }

            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              -webkit-transform: translatey(-50%);
              transform: translatey(-50%);
              width: 2.5rem;
              height: 2.5rem;
              background-color: $white;
              transition: all 0.25s linear;
              border: 0.15rem solid $blue;
            }
          }

          &.c-radio {
            input:checked + span:after {
              content: '';
              position: absolute;
              left: 0.5rem;
              top: 50%;
              -webkit-transform: translatey(-50%);
              transform: translatey(-50%);
              width: 1.5rem;
              height: 1.5rem;
              background-color: $blue;
              transition: all 0.25s linear;
            }
          }

          &.c-checkbox {
            span {
              &::before {
                top: 1.25rem;

                @include tablet-up {
                  top: 1.6rem;
                }
              }
            }

            input:checked + span:after {
              content: '';
              position: absolute;
              left: 0.3rem;
              top: 0.2rem;
              color: $white;
              transition: all 0.25s linear;
              background-image: url(~@/assets/images/icon-checkbox-checkmark.svg);
              background-size: contain;
              width: 2rem;
              height: 2rem;

              @include tablet-up {
                top: 0.6rem;
              }
            }
          }
        }

        .clearFilter {
          @include font-styles('Arial', 1.6rem, 500, normal, 3rem, 0, $gray);
          opacity: 0.5;

          &:not(.disabled) {
            opacity: 1;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }

    &-container {
      @include desktop-up {
        width: calc(100% - 32.5rem);
      }

      .listLabel {
        @include font-styles('Arial', 2rem, 300, normal, 2.6rem, 0, $gray);
        margin-bottom: 2.4rem;
      }
    }

    &-list {
      display: grid;
      gap: 4rem 2rem;
      grid-template-columns: repeat(2, 1fr);

      @include tablet-up {
        gap: 4rem 2rem;
        grid-template-columns: repeat(3, 1fr);
      }

      @include desktop-up {
        gap: 4rem;
        grid-template-columns: repeat(2, 1fr);
      }

      @include large-desktop-up {
        gap: 4rem;
        grid-template-columns: repeat(3, 1fr);
      }

      &__item {
        display: flex;
        flex-direction: column;
        padding: 0.8rem 0.8rem 1rem 0.8rem;
        align-items: center;
        justify-content: center;
        border-top: 3px solid $orange;
        border-right: 2px solid $divider;
        border-bottom: 2px solid $divider;
        border-left: 2px solid $divider;
        min-height: 21rem;

        @include tablet-up {
          padding: 1.6rem;
        }

        @include large-desktop-up {
          min-height: 35rem;
        }

        .ribbon {
          min-height: 2.5rem;

          &-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            text-transform: uppercase;

            div {
              @include font-styles('Arial Narrow', 1.2rem, 600, normal, normal, 0, $gray);

              @include tablet-up {
                font-size: 1.6rem;
                line-height: 1.44rem;
              }
            }

            .divider {
              width: 0.15rem;
              height: 1.2rem;
              margin: 0.05rem 0.5rem 0 0.5rem;
              background: rgba(48, 62, 72, 0.5);
              position: relative;
              border: none;
            }

            &:before {
              content: '';
              position: relative;
              background-image: url(~@/assets/images/icon-ribbon.svg);
              background-repeat: no-repeat;
              background-size: contain;
              margin-right: 0.5rem;
              width: 1.6rem;
              min-width: 1.6rem;
              height: 2.08rem;
              min-height: 2.08rem;
            }
          }
        }

        .partner-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;

          &.center {
            height: 100%;

            .title {
              margin-bottom: 0;
            }
          }

          .logo-container {
            height: 7.2rem;
            max-height: 7.2rem;
            width: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden;
            margin-bottom: 0.8rem;
            padding: 0.8rem;

            @include tablet-up {
              height: 12rem;
              max-height: 12rem;
              margin-bottom: 2rem;
            }

            img {
              max-height: 100%;
              max-width: 100%;
            }
          }
        }

        .title {
          color: $gray;
          font-weight: 300;
          font-size: 2rem;
          line-height: 2.6rem;
          margin-bottom: 0.8rem;
          text-align: center;

          @include desktop-up {
            font-size: 2.8rem;
            line-height: 3.5rem;
            margin-bottom: 2rem;
          }
        }

        .cta {
          display: inline-flex;
          text-transform: uppercase;
          justify-content: flex-start;
          align-items: center;
          @include font-styles('Arial Narrow', 1.8rem, 700, normal, 2.2rem, 0, $blue);
          margin-top: auto;

          &:after {
            content: '';
            position: relative;
            background-image: url(~@/assets/images/icon-arrow-right-blue-sm.svg);
            background-repeat: no-repeat;
            background-size: contain;
            margin-left: 1rem;
            width: 1.9rem;
            min-width: 1.9rem;
            height: 1.5rem;
            min-height: 1.5rem;
            left: 0;
            transition: left 0.25s;
          }
        }

        &:hover {
          .cta:after {
            left: 1rem;
          }
        }
      }

      .nofeaturedImage {
        clear: both;
        width: 100%;

        @include tablet-up {
          display: flex;
          flex-wrap: wrap;
        }

        > div {
          margin-bottom: 1rem;

          @include tablet-up {
            flex-basis: 50%;
          }

          a,
          span {
            display: inline-block;
            padding-right: 2rem;
          }
        }
      }
    }
  }

  &:deep() {
    .partner-placeholder {
      padding: 0 2rem;

      @include phone-only {
        display: none;
      }
    }
  }
}
</style>
